export enum FAQSubject {
	De_Winkel,
	Reparatie,
	Toestelinformatie,
	Garantie,
	Zakelijk,
	Contact,
}
